const spacing = (count) => {
    return `${count * 8}px`
}

const YELLOW = "#F6BE16"

const BLACK = "#181818"

export { spacing, BLACK, YELLOW }
